__turbopack_context__.v({
  "arrowRight": "Zs4ZoG_arrowRight",
  "boxShadowPulse": "Zs4ZoG_boxShadowPulse",
  "cappedEvent": "Zs4ZoG_cappedEvent",
  "columnHeader": "Zs4ZoG_columnHeader",
  "compactEvent": "Zs4ZoG_compactEvent",
  "compactEventList": "Zs4ZoG_compactEventList",
  "compactVenue": "Zs4ZoG_compactVenue",
  "compactView": "Zs4ZoG_compactView",
  "container": "Zs4ZoG_container",
  "dayContent": "Zs4ZoG_dayContent",
  "description": "Zs4ZoG_description",
  "desktopView": "Zs4ZoG_desktopView",
  "emptySlot": "Zs4ZoG_emptySlot",
  "eventCard": "Zs4ZoG_eventCard",
  "eventCardContent": "Zs4ZoG_eventCardContent",
  "eventCardTitleWrapper": "Zs4ZoG_eventCardTitleWrapper",
  "eventCardWrapper": "Zs4ZoG_eventCardWrapper",
  "eventDescription": "Zs4ZoG_eventDescription",
  "eventDescriptionWrapper": "Zs4ZoG_eventDescriptionWrapper",
  "eventMeta": "Zs4ZoG_eventMeta",
  "eventTime": "Zs4ZoG_eventTime",
  "eventTitle": "Zs4ZoG_eventTitle",
  "eventsList": "Zs4ZoG_eventsList",
  "fadeIn": "Zs4ZoG_fadeIn",
  "fadeInCentered": "Zs4ZoG_fadeInCentered",
  "fadeInFromBottom": "Zs4ZoG_fadeInFromBottom",
  "fullScheduleButton": "Zs4ZoG_fullScheduleButton",
  "gridLine": "Zs4ZoG_gridLine",
  "gridLines": "Zs4ZoG_gridLines",
  "headerControls": "Zs4ZoG_headerControls",
  "largeCard": "Zs4ZoG_largeCard",
  "liveEvent": "Zs4ZoG_liveEvent",
  "liveStream": "Zs4ZoG_liveStream",
  "liveStreamTab": "Zs4ZoG_liveStreamTab",
  "liveStreamTabContainer": "Zs4ZoG_liveStreamTabContainer",
  "liveStreamView": "Zs4ZoG_liveStreamView",
  "mobileTimeline": "Zs4ZoG_mobileTimeline",
  "mobileView": "Zs4ZoG_mobileView",
  "occupiedSlot": "Zs4ZoG_occupiedSlot",
  "partyAtTheTopOfTheWorld": "Zs4ZoG_partyAtTheTopOfTheWorld",
  "partyAtTheTopOfTheWorldConfetti": "Zs4ZoG_partyAtTheTopOfTheWorldConfetti",
  "partyAtTheTopOfTheWorldContent": "Zs4ZoG_partyAtTheTopOfTheWorldContent",
  "partyAtTheTopOfTheWorldHeader": "Zs4ZoG_partyAtTheTopOfTheWorldHeader",
  "pastEvent": "Zs4ZoG_pastEvent",
  "popup": "Zs4ZoG_popup",
  "popupAbove": "Zs4ZoG_popupAbove",
  "popupCentered": "Zs4ZoG_popupCentered",
  "popupDescription": "Zs4ZoG_popupDescription",
  "popupSpeakers": "Zs4ZoG_popupSpeakers",
  "popupSpeakersTitle": "Zs4ZoG_popupSpeakersTitle",
  "pulse": "Zs4ZoG_pulse",
  "roomColumn": "Zs4ZoG_roomColumn",
  "roomGrid": "Zs4ZoG_roomGrid",
  "roomGridWrapper": "Zs4ZoG_roomGridWrapper",
  "scheduleHeader": "Zs4ZoG_scheduleHeader",
  "sessionTitle": "Zs4ZoG_sessionTitle",
  "speaker": "Zs4ZoG_speaker",
  "speakers": "Zs4ZoG_speakers",
  "speakersTitle": "Zs4ZoG_speakersTitle",
  "splitDayView": "Zs4ZoG_splitDayView",
  "tab": "Zs4ZoG_tab",
  "tabContent": "Zs4ZoG_tabContent",
  "tabs": "Zs4ZoG_tabs",
  "tabsList": "Zs4ZoG_tabsList",
  "tabsRightControls": "Zs4ZoG_tabsRightControls",
  "timeEvents": "Zs4ZoG_timeEvents",
  "timeGroup": "Zs4ZoG_timeGroup",
  "timeLabel": "Zs4ZoG_timeLabel",
  "timeSlot": "Zs4ZoG_timeSlot",
  "timeline": "Zs4ZoG_timeline",
  "timelineSlot": "Zs4ZoG_timelineSlot",
  "title": "Zs4ZoG_title",
  "venueLabel": "Zs4ZoG_venueLabel",
  "venueTitle": "Zs4ZoG_venueTitle",
  "viewToggleButton": "Zs4ZoG_viewToggleButton",
});
